// Annual-event publications historically stored numbers, whereas the donation
// editor stores {montant, text}. Keep both readable without rewriting saved data.
export function normalizeDonationPresets(presets) {
    if (!Array.isArray(presets)) return [];
    return presets.flatMap(preset => {
        const entry = typeof preset === 'number' || typeof preset === 'string'
            ? {montant: preset} : preset;
        if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return [];
        const raw = entry.montant;
        if (typeof raw !== 'number' && typeof raw !== 'string') return [];
        const montant = Number(typeof raw === 'string' ? raw.replace(',', '.') : raw);
        // Same minimum as CardDon's manual amount validation.
        if (!Number.isFinite(montant) || montant < 1) return [];
        return [{...entry, montant}];
    });
}
